import type { DetailedHTMLProps, ImgHTMLAttributes } from "react";

import type { StyleXProps } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export type ImageSeoProps = StyleXProps<
    DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
> & {
    size: "o" | "l" | "m" | "t";
    styleXPicture?: stylex.StyleXStyles;
};

export default function ImageSeo({ src, styleX, alt, size, styleXPicture, ...props }: ImageSeoProps) {
    const isLegacy = src?.includes("goodie.pl") !== true;

    if (isLegacy) {
        return (
            <picture {...stylex.props(styleXPicture)}>
                <img {...props} {...stylex.props(styles.image, styleX)} alt={alt} src={src} loading="lazy" />
            </picture>
        );
    }

    src = src?.replace("raw.jpg", "").replace("raw.png", "");

    if (!alt) {
        throw new Error(`Missing alt for image with source '${src}'`);
    }

    return (
        <picture {...stylex.props(styleXPicture)}>
            <source type="image/avif" srcSet={`${src}-${size}.avif`} />
            <source type="image/webp" srcSet={`${src}-${size}.webp`} />
            <img {...props} {...stylex.props(styles.image, styleX)} alt={alt} src={`${src}-${size}.jpg`} />
        </picture>
    );
}

const styles = stylex.create({
    image: {
        objectFit: "contain",
        maxWidth: "100%",
    },
});
